import { render, staticRenderFns } from "./folderDialog.vue?vue&type=template&id=00399648"
import script from "./folderDialog.vue?vue&type=script&lang=js"
export * from "./folderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports